import { useEffect, useState } from "react";

const read = () => {
  const vv = window.visualViewport;
  const height = vv ? vv.height : window.innerHeight;
  return { height, offsetTop: vv ? vv.offsetTop : 0, keyboardOpen: window.innerHeight - height > 150 };
};

// Tracks the visible area above the on-screen keyboard and locks page scrolling while mounted.
export default function useVisualViewport(enabled = true) {
  const [vp, setVp] = useState(read);

  useEffect(() => {
    if (!enabled) return undefined;
    const vv = window.visualViewport;
    const update = () => setVp(read());
    const html = document.documentElement;
    const prev = [html.style.overflow, document.body.style.overflow, html.style.overscrollBehavior];
    html.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    html.style.overscrollBehavior = "none";
    vv?.addEventListener("resize", update);
    vv?.addEventListener("scroll", update);
    window.addEventListener("resize", update);
    update();
    return () => {
      [html.style.overflow, document.body.style.overflow, html.style.overscrollBehavior] = prev;
      vv?.removeEventListener("resize", update);
      vv?.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [enabled]);

  return vp;
}
